import { Directive, ElementRef, inject, input, InputSignal } from '@angular/core';

import { specialKeys } from '@ph-static-data/keyboard-key-codes';

@Directive({
  selector: '[decimalNumbersOnly]',
  host: {
    '(keydown)': 'onKeyDown($event)',
    '(paste)': 'onPaste($event)',
  }
})
export class DecimalNumberDirective {
  decimalNumbersOnly: InputSignal<boolean> = input.required();

  private _element = inject(ElementRef);
  private readonly _specialKeys = specialKeys;
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);

  onKeyDown(event: KeyboardEvent) {
    if (this.decimalNumbersOnly()) {
      const isCopyPasteAction = (event.metaKey || event.ctrlKey) && (event.key === 'c' || event.key === 'v');

      if (this._specialKeys.includes(event.key)) {
        return;
      }

      const current: string = this._element.nativeElement.value;
      const position = this._element.nativeElement.selectionStart;
      const next: string = [
        current.slice(0, position),
        event.key == 'Decimal' ? '.' : event.key,
        current.slice(position),
      ].join('');

      if (next && !String(next).match(this.regex) && !isCopyPasteAction) {
        event.preventDefault();
      }
    }
  }

  onPaste(event: ClipboardEvent): void {
    if (this.decimalNumbersOnly()) {
      const clipboardData = event.clipboardData ?? (window as Window & { clipboardData?: DataTransfer }).clipboardData;
      const pastedData = clipboardData?.getData('Text');

      if (pastedData == null || !pastedData.match(this.regex)) {
        event.preventDefault();
      }
    }
  }
}
